export const MuiInput = {
  styleOverrides: {
    input: {},
  },
};
